<template>
  <div class="container" ref="container" @mousemove.stop="dragElement" @mouseup.stop="endDrag">
    <div
      class="draggable"
      :class="{
        right: item.leftType === 'right'
      }"
      v-for="(item, index) in value"
      :key="index"
      ref="draggable"
      @dragstart.prevent
      :style="{ top: item.top + 'px', left: item.left + 'px', display: item.hidden ? 'none': 'flex' }"
      @mousedown="startDrag(index, $event)"
    >
      <div class="icon"></div>
      <div class="draggable-text" :style="{
        backgroundColor: item.bg,
        color: item.bg === '#FFF' ? '#000': '#FFF'
      }">
        {{item.price}}
      </div>
    </div>
  </div>
</template>

<script>
// dragBol 是否可以拖拽
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    dragBol: {
      type: Boolean,
      default: true
    }
  },
  model: {
    prop:'value',
    event: 'update',
  },
  data() {
    return {
      draggingIndex: -1,
      containerRect: null,
      initialMouseX: 0,
      initialMouseY: 0,
      initialTop: 0,
      initialLeft: 0
    };
  },
  methods: {
    startDrag(index, event) {
      if(!this.dragBol) return
      event.stopPropagation();
      this.draggingIndex = index;
      this.containerRect = this.$refs.container.getBoundingClientRect();
      this.initialMouseX = event.clientX;
      this.initialMouseY = event.clientY;
      this.initialTop = this.value[index].top;
      this.initialLeft = this.value[index].left;
    },
    dragElement(event) {
      event.stopPropagation();
      if(!this.dragBol) return
      if (this.draggingIndex !== -1) {
        let newTop = this.initialTop + event.clientY - this.initialMouseY;
        let newLeft = this.initialLeft + event.clientX - this.initialMouseX;

        // Restrict within container boundaries
        if (newTop < 0) newTop = 0;
        if (newLeft < 0) newLeft = 0;
        if (newTop + this.$refs.draggable[this.draggingIndex].offsetHeight > this.containerRect.height) {
          newTop = this.containerRect.height - this.$refs.draggable[this.draggingIndex].offsetHeight;
        }
        if (newLeft + this.$refs.draggable[this.draggingIndex].offsetWidth > this.containerRect.width) {
          newLeft = this.containerRect.width - this.$refs.draggable[this.draggingIndex].offsetWidth;
        }

        this.$set(this.value, this.draggingIndex,
          { top: newTop, left: newLeft,
            id: this.value[this.draggingIndex].id || '',
            title: this.value[this.draggingIndex].title || '',
            bg: this.value[this.draggingIndex].bg,
            price: this.value[this.draggingIndex].price,
            market_price: this.value[this.draggingIndex].market_price,
          hidden: this.value[this.draggingIndex].hidden,
          leftType: this.value[this.draggingIndex].leftType });
      }
    },
    endDrag() {
      this.draggingIndex = -1;
      if(!this.dragBol) return
      this.$emit('update', this.value)
    }
  }
};
</script>

<style scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  border: 1px solid #ccc;
}

.draggable {
  position: absolute;
  min-width: 60px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: move;
  &.right{
    flex-direction: row-reverse;
  }
  .draggable-text{
    padding: 0 8px;
    line-height: 16px;
    font-size: 12px;
    color: #000000;
    font-weight: 600;
    background: white;
  }
  .icon{
    width: 16px;
    height: 16px;
    margin: 0 8px;
    background: red;
  }
}
</style>
